import { getAmplitudeInstance } from '../amplitudeHelpers';
import MapOverlay from '../enums/MapOverlay';

type logExploreMapViewViewedParams = {
  heatmap_turned_on?: boolean;
  lat: number;
  lng: number;
  num_closed_pins_viewed: number;
  num_completed_pins_viewed: number;
  num_pois?: number;
  num_results_returned: number;
  num_saved_pins_viewed: number;
  overlays_applied?: MapOverlay[];
  zoom_level: number;
};

/**
 * User views the map view of search results. Refires when overlays/heatmaps are applied
 * @param params - Attributes to log with the amplitude event
 * @param params.heatmap_turned_on - Whether the user had the heatmap layer turned on. Note: user still may not see heatmap if none is available.
 * @param params.lat - Map focus latitude
 * @param params.lng - Map focus longitude
 * @param params.num_closed_pins_viewed - The number of closed pins viewed by the user
 * @param params.num_completed_pins_viewed - The number of completed pins viewed by the user
 * @param params.num_pois - The number of POI pins in the view
 * @param params.num_results_returned - The number of results returned to the user
 * @param params.num_saved_pins_viewed - The number of saved pins viewed by the user
 * @param params.overlays_applied - If the user is viewing the explore map with overlays, lists the overlays applied
 * @param params.zoom_level - Initial zoom level upon map view.
 */
const logExploreMapViewViewed = (
  {
    heatmap_turned_on,
    lat,
    lng,
    num_closed_pins_viewed,
    num_completed_pins_viewed,
    num_pois,
    num_results_returned,
    num_saved_pins_viewed,
    overlays_applied,
    zoom_level
  }: logExploreMapViewViewedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'explore map view viewed',
    {
      'heatmap turned on': heatmap_turned_on,
      lat,
      lng,
      'num closed pins viewed': num_closed_pins_viewed,
      'num completed pins viewed': num_completed_pins_viewed,
      'num pois': num_pois,
      'num results returned': num_results_returned,
      'num saved pins viewed': num_saved_pins_viewed,
      'overlays applied': overlays_applied,
      'zoom level': zoom_level
    },
    callback
  );
};

export default logExploreMapViewViewed;
